import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpClient, HttpParams } from "@angular/common/http";
import { env } from "@environments/environment";
import { map } from "rxjs/operators";
import { OrganizationAdapter } from "@app/adapters/organization.adapter";
import { PageModel } from "@app/models/page.model";
import { OrganizationViewModel } from "@app/models/organization.model";
import { OrganizationShortAdapter } from "@app/adapters/organization-short.adapter";
import { OrganizationShortModel } from "@app/models/organization-short.model";

@Injectable({ providedIn: "root" })
export class OrganizationApiService {

  constructor(private readonly adapter: OrganizationAdapter,
              private readonly organizationShortAdapter: OrganizationShortAdapter,
                private readonly http: HttpClient) {
  }

  protected baseUrl = `${env.logisticsServiceBackend}/logistics/v1/organizations`;

  getOrganizationsMappedWithRecipients(year: number, roleRoute: string, params: HttpParams): Observable<PageModel<OrganizationViewModel>> {
    return this.http.get<PageModel<OrganizationViewModel>>(`${this.baseUrl}/recipients/${roleRoute}/${year}`, { params }).pipe(
      map(data => new PageModel<OrganizationViewModel>({
        totalPages: data.totalPages,
        totalElements: data.totalElements,
        content: this.adapter.adaptArray(data.content),
      }),
      ),
    );
  }

  getOrganizationsForRecipientsMapping(roleRoute: string, params: HttpParams): Observable<OrganizationShortModel[]> {
    return this.http.get<PageModel<OrganizationShortModel>>(`${this.baseUrl}/${roleRoute}`, { params }).pipe(
      map(data => this.organizationShortAdapter.adaptArray(data.content),
      ),
    );
  }

}
